module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "mt-8"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "offset-md": "2",
      "lg": "6",
      "offset-lg": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center pa-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-avatar', {
    staticClass: "ma-1",
    attrs: {
      "size": 240,
      "color": "transparent"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logoUrl,
      "lazy-src": ''
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("Mailadresse muss verifiziert werden")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_vm._v("\n              Lieber Bundesbruder, "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n              deine E-Mailadresse "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.mail))]), _vm._v(" wurde bisher nicht verifiziert. "), _c('br'), _vm._v("\n              Um auf Korpodesk zuzgreifen musst du deine E-Mailadresse\n              bestätigen, in dem du auf den Verifizierungslink in der zugesendeten Mail klickst. Solltest\n              du keine Mail bekommen haben, kannst du dir eine neue Mail zusenden lassen. Bitte schau auch in deinem Spam-Ordner nach."), _c('br'), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendVerifizierungsMail()
      }
    }
  }, [_vm._v("Mail erneut senden")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    }
  }, [_vm._v("Ich habe die Mailadresse bestätigt")]), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v("\n              Probleme bei der Anmeldung?\n              "), _c('br'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "href": "https://wa.me/491634445098",
            "target": "_blank"
          }
        }, on), [_c('v-icon', [_vm._v("mdi-whatsapp")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "href": "mailto:breuerbe@gmail.com",
            "target": "_blank"
          }
        }, on), [_c('v-icon', [_vm._v("mail")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Mail")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd6572ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/VerifiziereMail.vue
// module id = 813
// module chunks = 15